import type { App } from 'vue';
import { watch } from 'vue';
import { i18n } from './create-i18n';
import { applyLocaleSideEffects } from './side-effects';

/**
 * Install the i18n instance + wire locale-change side effects (DOM class /
 * Sentry tag / missing-keys cache reset) as a watcher on the global `locale`
 * ref — any code path that changes the locale (including direct
 * `i18n.global.locale.value = code`) triggers the same side effects.
 */
export function installI18n(app: App): void {
  app.use(i18n);
  watch(
    i18n.global.locale,
    (newLocale) => {
      applyLocaleSideEffects(String(newLocale));
    },
    { immediate: true }
  );
}
